import React, { useMemo, useEffect } from 'react';

import useAPI from '../../../../hooks/useAPI';
import DataTable from '../../../../components/DataTable';
import { producaov2 } from '../../../../services/apis';

export default function TicketsSummary() {
  const { data, isLoading } = useAPI('/admin/operacoes/tickets');

  useEffect(() => {
    producaov2.get("/admin/operacoes/update-expiradas").then(res => console.log("OPERACOES:: ", res.data));
  }, []);

  const tickets = useMemo(() => {
    const tutorIdsMainOrder = [36119, 18805, 48, 7515, 30879];

    data?.sort((a, b) => {
      const valueA = tutorIdsMainOrder.includes(a.id)
        ? tutorIdsMainOrder.indexOf(a.id)
        : tutorIdsMainOrder.length;

      const valueB = tutorIdsMainOrder.includes(b.id)
        ? tutorIdsMainOrder.indexOf(b.id)
        : tutorIdsMainOrder.length;

      return valueA - valueB;
    });

    return data;
  }, [data]);

  return (
    <DataTable
      showPagination={false}
      rowsPerPage={5}
      isLoading={isLoading}
      columns={[
        { key: 'tutor', name: 'Consultor' },
        { key: 'pending', name: 'Dúvida Em Aberto' },
        { key: 'expired', name: 'Dúvidas Expiradas' },
        { key: 'answered', name: 'Dúvidas Respondidas' },
      ]}
      rows={tickets?.map(ticket => ({
        tutor: `${ticket.nome.split(" ")[0].toUpperCase()} ${ticket.nome.split(" ").pop().toUpperCase()}`,
        pending: ticket.countPendente,
        expired: ticket.countExpirada,
        answered: ticket.countRespondida
      }))}
    />
  )
}